<template>
  <v-app>
    <menu-drawer />
    <router-view></router-view>
    <v-dialog v-model="dialog" persistent max-width="350">
       <message-dialog  v-on:no-button-tapped="noButtonTappedDialog" v-on:ok-button-tapped="okButtonTappedDialog"
        v-bind:message="dialogMessage" v-bind:showYesNo="isYesNoDialog"/>
    </v-dialog>
     <v-dialog v-model="showVacationDetail" persistent max-width="550" no-click-animation>
         <div style="background-color: white; height: 650px">
            <VacationDetail v-if="showVacationDetail" v-bind:vacationid="vacationID"></VacationDetail>      
         </div>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapActions } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import MessageDialog from "@/components/commonui/MessageDialog.vue";
import { ListEvents } from "@/utilities/CommonUtilities";
import MenuDrawer from "@/components/home/MenuDrawer.vue";
import VacationDetail from "@/components/vacations/VacationDetail.vue";

Vue.use(Loading);

let loaderView;
let unwatcher;
export default {
  name: 'iVacation',
  components: { MessageDialog, MenuDrawer, VacationDetail},
  data: function() {
    return { 
      dialog: false,
      dialogMessage:'',
      isYesNoDialog: true,

      showVacationDetail: false,
      vacationID:null
    }
  },
  mounted() {
    // khi bấm nút "Back" hoặc "Forward" trên trình duyệt, sẽ reload lại trang hiện tại
    window.onpopstate = () => {
    this.$router.go(0);
    };
  },
  methods: {
    //dialogs
    okButtonTappedDialog() {
      this.dialog = false;
      if(!this.isYesNoDialog) { 
        this.notifyBus.$emit(ListEvents.tappedOKAction);
        return;
      }
      this.notifyBus.$emit(ListEvents.dialogSelectedAction, true);
    },
    noButtonTappedDialog: function() {
      this.dialog = false;
      this.notifyBus.$emit(ListEvents.dialogSelectedAction, false);
    },
    showYesNoDialog(message) {
        this.dialogMessage = message;
        this.dialog = true;
        this.isYesNoDialog = true;
    },
    showOKDialog(message) {
        this.dialogMessage = message;
        this.dialog = true;
        this.isYesNoDialog = false;
    },
    ...mapActions({
        resetAllTabInfo: "homeData/resetAllTabInfo"
    }),
  },
  created() {
    this.$store.commit("loadCachedInfo");
    
    this.notifyBus.$on(ListEvents.showLoadingIndicator, () => {
      loaderView = this.$loading.show({
                  container: null,
                  canCancel: false,
                  color:'#5e81ed'
                });
    });
    this.notifyBus.$on(ListEvents.hideLoadingIndicator, () => {
      if(loaderView != null) {
        loaderView.hide();
      }
    });

    //showVacationDetail
    this.notifyBus.$on(ListEvents.showVacationDetail, (vacationID) => {
      this.showVacationDetail = true;
      this.vacationID = vacationID;
    });
    
    this.notifyBus.$on(ListEvents.closeVacationDetail, () => {
      this.showVacationDetail = false;
    });

    this.notifyBus.$on(ListEvents.showYesNoDialog, this.showYesNoDialog);
    this.notifyBus.$on(ListEvents.showOKDialog, this.showOKDialog);

    this.notifyBus.$on(ListEvents.reloadAllTabs,(reloadAll) => {
      if(reloadAll) {
        this.resetAllTabInfo();
      }
    });

    unwatcher = this.$store.watch(state => state.token, (token) => {
        if(token == null) {
            this.showVacationDetail = false;
            this.$router.push({name: "login"});
        }
    });
  },
  beforeDestroy() {
    unwatcher();
  },
  inject: ["notifyBus"],
};
</script>

<style>
  @import url(https://fonts.googleapis.com/css?family=Open+Sans);
  body{
    font-family: 'Open Sans', Arial, sans-serif !important;
  }
  .v-application {
    font-family: 'Open Sans', Arial, sans-serif !important;
  }
</style>
